import { render } from "./BilletForm.vue?vue&type=template&id=5298a824"
import script from "./BilletForm.vue?vue&type=script&lang=js"
export * from "./BilletForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__